import { Grid, makeStyles, Typography, useMediaQuery } from '@material-ui/core';
import { GitHub, LanguageRounded } from '@material-ui/icons';
import React from "react";
import ChipArray from './ChipArray';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    margin: 'auto 0'
  },
  titleFont: {
    letterSpacing: '1px',
    margin: '0.2em auto'
  },
  responsive: {
    flexGrow: 1,
    display: 'flex',
    margin: '1vh 1vw'
  },
  projectBackHeading: {
    padding: theme.spacing(1),
    textTransform: 'uppercase',
    breakWord: 'break-all',
  },
  paragraphText : {
    padding: theme.spacing(1)
  }
}));

function FlipCard(props) {
  const classes = useStyles();
  const matches = useMediaQuery('(max-width: 700px)');
  const {name, description, thumbnail, techUsed, github, live} = props;
  return (
    <Grid item xs={12} className={matches ? classes.responsive : classes.root}>
      <div className="flip-card">
        <div className="flip-card-inner">
          <div className="flip-card-front">
            <img src={thumbnail} alt="Avatar" />
            <Typography variant='h6' className={classes.titleFont}>"{name}"</Typography>
            <ChipArray techUsed={techUsed}/>
          </div>
          <div className="flip-card-back">
            <Typography className={classes.projectBackHeading} variant={matches ? 'h6' : 'h4'}>{name}</Typography>
            <Typography className={classes.paragraphText} variant='body1'>{description}</Typography>
            <div className='project-link-container'>
              {github && <a href = {github} target='_blank' rel='noopener noreferrer'><GitHub fontSize='small'/></a>}
              {live && <a href = {live} target='_blank' rel='noopener noreferrer'><LanguageRounded fontSize='small'/></a>}
            </div>
          </div>
        </div>
      </div>
    </Grid>
  );
}

export default FlipCard;
